<div class="p-fluid" [formGroup]="form">
  <kodit-field fieldLabel="Pošiljalac" fieldLabelFor="masovno-slanje-from">
    <kodit-email-dropdown [formCtrl]="form.controls.fromId"></kodit-email-dropdown>
  </kodit-field>
  <kodit-field fieldLabel="Naslov" fieldLabelFor="masovno-slanje-naslov">
    <kodit-text-input
      formCtrlId="masovno-slanje-naslov"
      [formCtrl]="form.controls.mailNaslov"
    ></kodit-text-input>
  </kodit-field>
  <kodit-field fieldLabel="Napomena" fieldLabelFor="masovno-slanje-poruka">
    <p-editor
      id="masovno-slanje-poruka"
      [formControl]="customPorukaCtrl"
      placeholder="Opciono - ista napomena se upisuje na svaki predračun (vidi se na PDF-u)"
      [style]="{ height: '150px' }"
    >
      <ng-template pTemplate="header">
        <span class="ql-formats">
          <button type="button" class="ql-bold" aria-label="Bold"></button>
          <button type="button" class="ql-italic" aria-label="Italic"></button>
        </span>
      </ng-template>
    </p-editor>
    <kodit-error-info-max-length
      [formCtrl]="customPorukaCtrl"
    ></kodit-error-info-max-length>
  </kodit-field>
  <div class="p-d-flex p-flex-column">
    <span class="note">
      *** Biće poslato {{ racunIds.length }} predračuna, svaki na sve email adrese iz kontakata kupca sa predračuna.
      Poslati predračuni prelaze u status Poslato, a datum izdavanja postaje datum slanja. Kupci bez ijednog kontakta
      sa email adresom neće dobiti predračun. Dobićete notifikaciju kada se slanje završi.
    </span>
  </div>
</div>
